import { HirPolicyPermissionsService } from './hir-policy-permissions.service';
import { RoleConstants } from './role.constants';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from '../../app-routing.module';
import { CoreModule } from '../../../../shared/core/core.module';
import { HirAuthApiService } from "./hir-auth.service";
import { HirUserManagementService } from "./hir-user-management.service";
import { HirAccessService } from "./hir-access.service";
import { ApiModule } from "../../api/api.module";
import { HirAuthRequestInterceptor } from './hir-auth-request.interceptor';
import { HirPolicyPermissionsGuard } from './hir-policy-permissions.guard';


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ApiModule,
    AppRoutingModule
  ],
  declarations: [
  ],

  providers: [
    HirAuthApiService,
    HirPolicyPermissionsService,
    HirPolicyPermissionsGuard,
    RoleConstants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HirAuthRequestInterceptor,
      multi: true
    },
    HirUserManagementService,
    HirAccessService
  ],exports:[]
})
export class CoreHirModule { }
